import { createSlice } from '@reduxjs/toolkit'

interface ToolTextAnnotationState {
  /**
   * Flag to indicate if batch generation should be triggered.
   */
  batchGenerate: boolean

  /**
   * Flag to indicate if batch generation is allowed.
   * Used to enable/disable the batch generation button
   * due to all shapes already having text annotations.
   */
  canBatchGenerate: boolean
}

const initialState: ToolTextAnnotationState = {
  canBatchGenerate: false,
  batchGenerate: false,
}

export const textAnnotationSlice = createSlice({
  name: 'blueprint-editor/tools/text-annotation',
  initialState,
  reducers: {
    /**
     * Trigger batch generation of text annotations.
     */
    setBatchGenerate: (state, action: { payload: boolean }) => {
      state.batchGenerate = action.payload
    },

    /**
     * Set whether batch generation is allowed.
     */
    setCanBatchGenerate: (state, action: { payload: boolean }) => {
      state.canBatchGenerate = action.payload
    },

    // ## Reset state
    reset: () => initialState,
  },
})

export const { setBatchGenerate, setCanBatchGenerate, reset } = textAnnotationSlice.actions
export default textAnnotationSlice.reducer
